<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template >
<div>

  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
  <div id="loading-add-catalog-sidebar" class="vs-con-loading__container">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? $t('add_new') : $t('update') }} {{$t('element')}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('agency')}}</label>
              <v-select
                :options="categoriesOptions"
                label="name"
                :reduce="agency => agency.id"
                v-model="agency"
                v-validate="'required'"
                name="agency"
                class="w-full"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('agency')"
              >{{ errors.first('agency') }}</span>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$tc('type')|capitalize}}</label>
              <v-select
                :options="typesOptions"
                label="name"
                :reduce="type => type.id"
                v-model="type"
                v-validate="'required'"
                name="type"
                class="w-full"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('type')"
              >{{ errors.first('type') }}</span>
           </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label for="activity_name" text-align="right">{{ $t('activity_name')}}</label>
           <vs-input
                type="text"
                v-model="dataName"
                class="w-full"
                id="activity_name"
                v-validate="'required|min:10'"
                name="activity_name"
                autocomplete="off"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('activity_name')"
              >{{ errors.first('activity_name') }}</span>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label for="duration" text-align="right">{{ $t('duration')}}</label>
            <vs-input
                type="text"
                v-model="duration"
                class="w-full"
                id="duration"
                autocomplete="off"
                name="duration"
                v-validate="'required|numeric'"
              />
           <span
                class="text-danger text-sm"
                v-show="errors.has('duration')"
              >{{ errors.first('duration') }}</span>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label for="regulation" text-align="right">{{$t('regulation')}}</label>
            <vs-input
                type="text"
                v-model="regulation"
                class="w-full"
                id="regulation"
                autocomplete="off"
                name="regulation"
                v-validate="'required'"
              />
            <span
                class="text-danger text-sm"
                v-show="errors.has('regulation')"
              >{{ errors.first('regulation') }}</span>
            </div>
          </div>


      <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label for="frequency" text-align="right">{{$t('frequency')}}</label>
              <!-- base-class="custom-auto" -->
              <!-- <autocomplete
                :search="search"
                :placeholder="$t('search_frequency')"
                :get-result-value="getResultValue"
                @submit="handleSubmit"
                ref="autocomplete"
                class="auto-catalog"
              ></autocomplete> -->

               <v-select
                :options="frequencyOptions"
                label="name"
                :reduce="f => f.id"
                v-model="frequency"
                v-validate="'required'"
                name="type"
                class="w-full"
              />
            </div>
        </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label for="government_fee" text-align="right">{{$t('government_fee')}}</label>
            <vs-input
                type="text"
                v-model="government_fee"
                class="w-full"
                id="government_fee"
                autocomplete="off"
                name="government_fee"
                v-validate="'decimal'"
                maxlength="9"
              />
            <span
                class="text-danger text-sm"
                v-show="errors.has('government_fee')"
              >{{ errors.first('government_fee') }}</span>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label for="third_party_fee" text-align="right">{{$t('third_party_fee')}}</label>
            <vs-input
                type="text"
                v-model="third_party_fee"
                class="w-full"
                id="third_party_fee"
                autocomplete="off"
                name="third_party_fee"
                v-validate="'decimal'"
                maxlength="9"
              />
            <span
                class="text-danger text-sm"
                v-show="errors.has('third_party_fee')"
              >{{ errors.first('third_party_fee') }}</span>
             </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label for="savings" text-align="right">{{$t('savings')}}</label>
            <vs-input
                type="text"
                v-model="savings"
                class="w-full"
                id="savings"
                autocomplete="off"
                name="savings"
                v-validate="'decimal'"
                maxlength="9"
              />
            <span
                class="text-danger text-sm"
                v-show="errors.has('savings')"
              >{{ errors.first('savings') }}</span>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label for="description" text-align="right">{{$t('description')}}</label>
            <vs-input
                type="text"
                v-model="description"
                class="w-full"
                id="description"
                autocomplete="off"
                name="description"
                v-validate="'min:10'"
              />
            <span
                class="text-danger text-sm"
                v-show="errors.has('description')"
              >{{ errors.first('description') }}</span>
           </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label for="tacna_responsibility" text-align="right">{{$t('tacna_responsibility')}}</label>
            <vs-input
                type="text"
                v-model="tacna_responsibility"
                class="w-full"
                id="tacna_responsibility"
                autocomplete="off"
                name="tacna_responsibility"
                v-validate="'min:5'"
              />
           <span
                class="text-danger text-sm"
                v-show="errors.has('tacna_responsibility')"
              >{{ errors.first('tacna_responsibility') }}</span>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label for="client_responsibility" text-align="right">{{$t('client_responsibility')}}</label>
            <vs-input
                type="text"
                v-model="client_responsibility"
                class="w-full"
                id="client_responsibility"
                autocomplete="off"
                name="client_responsibility"
                v-validate="'min:5'"
              />
            <span
                class="text-danger text-sm"
                v-show="errors.has('client_responsibility')"
              >{{ errors.first('client_responsibility') }}</span>
            </div>
          </div>
          <span
            class="text-danger text-sm"
            v-show="errors.has('item-name')"
          >{{ errors.first('item-name') }}</span>
        </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{$t('submit')}}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('cancel')}}</vs-button>
    </div>
  </div>
  </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import general from '@/http/requests/general/index.js'
import vSelect from 'vue-select'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    categoriesOptions: {
      type: Array,
      required: true
    },
    typesOptions: {
      type: Array,
      required: true
    },
    /* frequencyOptions: {
      type: Array,
      required: true
    }, */
    data: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Autocomplete
  },
  data () {
    return {
      //form variables
      dataId: null,
      dataName: '',
      agency: null,
      type: null,
      regulation: '',
      description: '',
      government_fee: '',
      third_party_fee: '',
      duration: '',
      tacna_responsibility: '',
      client_responsibility: '',
      frequency:'',
      savings: '',
      //settings
      frequencyOptions:[],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val){
        //this.$refs.autocomplete.value = ''
        return
      } 

      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { 
          id, 
          name,
          agency_id, 
          agency, 
          type, 
          description, 
          regulation, 
          frequency_id, 
          duration,
          savings,
          third_party_fee,
          responsibility_tacna, 
          responsibility_client, 
          government_fee
        } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataName = name
        this.agency = agency_id
        this.frequency = frequency_id
        this.type = type
        this.regulation = regulation
        this.description = description
        this.government_fee = government_fee
        this.duration = duration
        this.third_party_fee= third_party_fee
        this.tacna_responsibility = responsibility_tacna
        this.client_responsibility = responsibility_client
        this.savings = savings
        // this.$refs.autocomplete.setValue({name:frequency})
        // this.$refs.autocomplete.core.value=frequency
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        general.frequencies()
              .then((res) => {
                this.frequencyOptions = res.data.frequencies
                //this.frequency = this.frequencyOptions[0].id
              })
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any()
        && this.agency
        && this.type
        && this.dataName
        && this.duration
        && this.regulation
        //&& this.frequency
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    //frequency() {return this.$refs.autocomplete.core.value}
  },
  methods: {
    initValues () {
      if (this.data.id) return
      /* Required fields */
      this.dataId = null
      this.agency = this.categoriesOptions[0].id
      this.type = this.typesOptions[0].id
      this.dataName = 'Default Name'
      this.duration = '90'
      this.regulation = 'Default'
      /* No required fields */
      this.description = 'No Description'
      this.tacna_responsibility = 'Default'
      this.client_responsibility = 'Default'
      this.third_party_fee = '0'
      this.government_fee = '0'
      this.savings = '0'
      this.frequency = this.frequencyOptions[0].id
    },
    submitData () {
      //this.$refs.autocomplete.value = ''
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
          id: this.dataId,
          activity_name: this.dataName,
          agency: this.agency,
          type: this.type,
          regulation: this.regulation,
          description: this.description,
          government_fee: this.government_fee,
          third_party_fee: this.third_party_fee,
          duration: this.duration,
          tacna_responsibility: this.tacna_responsibility,
          client_responsibility: this.client_responsibility,
          frequency: this.frequency,
          savings: this.savings
        }
        // console.log(obj);
        // return;
        this.openLoading()
        if (this.dataId !== null && this.dataId >= 0) {
        //UPDATE AXIOS
        this.$store.dispatch('catalog/updateCatalog',obj)
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title: this.$i18n.messages[this.$i18n.locale].success,
            text: this.$i18n.messages[this.$i18n.locale].item_updated
          })
          this.closeLoading()
          this.$emit('closeSidebar')
          this.$emit('submitSuccess', res)
        })
        .catch(err => {
          this.closeLoading()
          console.log(err)
          /* if (422 === err.response.status) {
            let errors = err.response.data.errors
            let errorArray = Object.keys(errors).map(function(key) {
              return [key, errors[key]]
            })
            errorArray.forEach(element => {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: element[1][0]
              })
            })
          }else{
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: 'SERVER ERROR'
              })
          } */
        })

        } else {
        //STORE AXIOS
        delete obj.id
        obj.popularity = 0
        this.$store.dispatch('catalog/addCatalog',obj)
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title: this.$i18n.messages[this.$i18n.locale].success,
            text: this.$i18n.messages[this.$i18n.locale].item_added,
          })
          this.closeLoading()
          this.$emit('closeSidebar')
          this.$emit('submitSuccess', res)
        })
        .catch(err => {
          this.closeLoading()
          if (422 === err.response.status) {
            let errors = err.response.data.errors
            let errorArray = Object.keys(errors).map(function(key) {
              return [key, errors[key]]
            })
            errorArray.forEach(element => {
              this.$vs.notify({
                color: 'danger',
                title: this.$i18n.messages[this.$i18n.locale].attention,
                text: element[1][0]
              })
            })
          }else{
              this.$vs.notify({
                color: 'danger',
                title: this.$i18n.messages[this.$i18n.locale].attention,
                text: 'SERVER ERROR'
              })
          }
        })
        }
        }
      })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    openLoading() {
      this.$vs.loading({
        container: '#loading-add-catalog-sidebar',
        scale: 0.6
      })
    },
    closeLoading() {
      this.$vs.loading.close('#loading-add-catalog-sidebar > .con-vs-loading')
    },
    search(input) {
      return this.frequencyOptions.filter(item => item.name.toLowerCase().includes(input.toLowerCase()))
    },
    getResultValue(result) {
      return result.name
    },
    handleSubmit(result) {
    // this.$refs.autocomplete.core.value=result.name
    }
  }
}

</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.autocomplete-input{
        width: 100% !important;
        border-radius: 5px;
        border: solid 1px lightgray !important;
        height: 2.7rem;
        font-size: 1rem;
        padding: 5px;
}
</style>
